export { CustomerAuthApiError } from './customer-auth-api/core'
export type {
  CustomerActivationValidationStatus,
  PublicRuntimeConfigPayload,
} from './customer-auth-api/types'
export { fetchPublicRuntimeConfig } from './customer-auth-api/runtime'
export {
  activateCustomer,
  forgotPassword,
  loginCustomer,
  refreshCustomerSession,
  requestCustomerLoginPasskeyOptions,
  resendActivationByEmail,
  resetPassword,
  signupCustomer,
  validateActivationToken,
  validateResetPasswordToken,
  verifyCustomerLoginPasskey,
  verifyCustomerLoginSecondFactor,
} from './customer-auth-api/auth'
export {
  fetchCustomerMe,
  logoutCustomer,
  updateCustomerProfile,
} from './customer-auth-api/account'
export {
  fetchCustomerPasskeys,
  removeCustomerPasskey,
  requestCustomerPasskeyRegisterOptions,
  verifyCustomerPasskeyRegistration,
} from './customer-auth-api/passkeys'
